import { useSelector } from 'react-redux';

import { ca } from '@cian/analytics';

import { selectDeviceType, selectPageType } from '../../selectors/page';
import { mapPageTypeToAnalytics } from '../../utils/getPageviewObject';
import { getSiteType } from '../../utils/getSiteType';
import { useApplicationContext } from '../../utils/applicationContext';
import { EPlatform } from '@cian/webview/shared';
import { selectUserId } from '../../selectors/user';

export const useTracking = () => {
  const { config } = useApplicationContext();
  const pageType = useSelector(selectPageType);
  const deviceType = useSelector(selectDeviceType);
  const userId = useSelector(selectUserId);
  const platform = config.get<EPlatform | null>('web.platform') ?? null;
  const extra = platform ? { type: platform } : undefined;

  const trackCustomNewpage = () => {
    ca('pageview', {
      page: {
        pageType: mapPageTypeToAnalytics[pageType],
        siteType: getSiteType(deviceType),
        extra,
      },
      user: {
        userId,
      },
    });
  };

  return {
    trackCustomNewpage,
  };
};
